import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { useGetDataProperty } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperty';
import { getPropertyIcon } from 'automation-ui-formula-editor/data-sources/utils/getPropertyIcon';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import FormulaEditorTokenTag from 'automation-ui-formula-editor/formula-editor/FormulaEditorTokenTag';
import { jsx as _jsx } from "react/jsx-runtime";
const FormulaEditorResolvedTag = ({
  fieldName
}) => {
  const {
    prefix,
    property
  } = getTokenParts(fieldName);
  const {
    data,
    loading,
    error: queryError
  } = useGetDataProperty({
    prefix,
    property
  });
  const dataSource = data === null || data === void 0 ? void 0 : data.dataSourceProperty;
  const label = dataSource === null || dataSource === void 0 ? void 0 : dataSource.label;
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 80
    });
  }
  return /*#__PURE__*/_jsx(FormulaEditorTokenTag, {
    label: label || property,
    propertyIconName: getPropertyIcon({
      dataProperty: dataSource
    }),
    useError: !!queryError || !dataSource || !label,
    verticalAlign: "baseline"
  });
};
export default FormulaEditorResolvedTag;